import { useForm } from "react-hook-form";
import { AddQuestionInput, addQuestionInputSchema } from "../zod/AddQuestion";
import { zodResolver } from "@hookform/resolvers/zod";

export const useUserQuestionForm = (answererId: string, title?: string) => {
    const {
        control,
        handleSubmit,
        formState: { isValid, isDirty },
    } = useForm<AddQuestionInput>({
        mode: "onChange",
        resolver: zodResolver(addQuestionInputSchema),
        defaultValues: {
            title: title ?? "",
            answererId,
        },
    });

    return {
        control,
        handleSubmit,
        isValid,
        isDirty,
    };
};
